import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";

import { PlantsBrandingComponent } from "../branding/plants-branding.component";
import { PlantsPrimaryNavComponent } from "../primary-nav/plants-primary-nav.component";

@Component({
  selector: "plants-footer",
  imports: [RouterLink, PlantsBrandingComponent, PlantsPrimaryNavComponent],
  templateUrl: "./plants-footer.component.html",
  styleUrls: ["./plants-footer.component.scss"]
})
export class PlantsFooterComponent {}
